import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = function (data) {
  return fetch({
    url: "/admin/login",
    method: "post",
    data: data,
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/auth/register",
    method: "post",
    data: data,
  });
};
AuthService.getProfile = function () {
  return fetch({
    url: "/admin/getMyProfile",
    method: "get",
  });
};

AuthService.updateProfile = function (data) {
  return fetch({
    url: "/admin/update",
    method: "put",
    data,
  });
};
export default AuthService;
